import IFlagDataReport from "@/models/reports/flag-data.report";
import { MapsUtil } from "@/utils/maps.util";
import BasePopup from "../base.popup";

export default class FlagPopup implements BasePopup {
    data: IFlagDataReport
    offSet = [0, -50]

    constructor(feature: any) {
        this.data = feature.get("data")
    }

    getParamsAddress(): { id: string; lat: number; lon: number } {
        return {
            id: `flag_${this.data.type}`,
            lat: this.data.latitude,
            lon: this.data.longitude,
        }
    }

    getContent(): string {
        const device = this.data.report.device
        return `
        <div class="cajatitle">
            <img src=${require('@/assets/img/pointers/' + this.data.icon + '.png')} >
            <p class="m-0 ms-1 fw-bold fs-6">${this.data.title}</p>
        </div>
        <hr >
        <div class="lineas align-items-center">
            <p class="propiedad m-0">Unidad: </p>
            <p class="valor m-0 ms-1">
                <img class="w-auto p-0" style="height: 25px" src=${require('@/assets/img/devices/' + device.icon + '.png')} >
                ${device.plate}
            </p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Fecha: </p>
            <p class="valor m-0 ms-1">${this.data.date}</p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Dirección: </p>
            <p class="valor m-0 ms-1" id="flag_${this.data.type}"></p>
        </div>
        <div class="lineas">
            <a class="link" href="${MapsUtil.getGoogleMapsURL(this.data?.latitude, this.data?.longitude)}" target="_blank" rel="noopener noreferrer">Link Google Maps</a>
        </div>
        `
    }
}